import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from 'components/atoms/Heading';
import Text from 'components/atoms/Text';
import Icon from 'components/atoms/Icon';
import { info } from 'components/atoms/Icon/icons';
import Link from 'components/atoms/Link';
import Block from 'components/atoms/Block';
import HTMLString from 'components/utilities/HTMLString';
import classNames from 'classnames';
import { translate } from 'utils/translate';
import { iconLookup } from 'utils/iconLookUp';
import * as styles from './Product.scss';

const SustainabilityTab = ({ sustainabilityData, productFacilities }) => {
  const groups = sustainabilityData.sustainabilityGroups;

  // id here is the facility group id for facility-notes
  const productNote = productFacilities.find(x => x.id === 505443);

  function makeBlocks(groups, productNote) {
    const blocks = [];
    for (let i = 0; i < groups.length; i++) {
      blocks.push(
        <Block>
          <H3 className={styles.sustainabilityHeader}>
            <Icon
              name={iconLookup[groups[i].icon] ?? info}
              className={styles.sustainabilityIcon}
            />
            {groups[i].title ?? 'No text set'}
          </H3>
          <Link
            href={groups[i].linkHref}
            className={styles.sustainabilityLinkText}
          >
            {groups[i].linkText ?? 'No text set'}
          </Link>
          <Text
            as="p"
            id="facilityInfoText"
            className={styles.sustainabilityInfoText}
          >
            {groups[i].text ?? 'No text set'}
          </Text>
        </Block>,
      );
      for (let j = 0; j < groups[i].items.length; j++) {
        if (groups[i].items[j].text) {
          blocks.push(
            <Block className={styles.sustainabilityInfoTextContainer}>
              <Text
                as="p"
                className={styles.sustainabilityInfoText}
                id="InfoSub"
              >
                {groups[i].items[j].text}
              </Text>
            </Block>,
          );
        }
      }
    }
    /**
     * Check for facility notes,
     * the input might come from a rich text editor so we use <HTMLString> to print text
     */
    if (productNote != undefined) {
      blocks.push(
        <Block className={styles.sustainabilityInfoTextContainer}>
          <HTMLString
            className={styles.facilityNotes}
            html={productNote.notes}
          ></HTMLString>
        </Block>,
      );
    }

    blocks.push(
      <Block className={styles.sustainabilityInfoTextContainer}>
        <HTMLString
          className={classNames(styles.facilityNotes, styles.disclaimer)}
          html={
            sustainabilityData.sustainabilityDisclaimerText ??
            translate('/product/selfReporting')
          }
        ></HTMLString>
      </Block>,
    );
    return blocks;
  }

  return (
    <Block>
      <H3 className={styles.sustainabilityHeader}>
        {sustainabilityData.sustainabilityLeadHeader}
      </H3>
      <Text className={styles.sustainabilitySubText}>
        {sustainabilityData.sustainabilityLeadText}
      </Text>
      {makeBlocks(groups, productNote)}
    </Block>
  );
};

SustainabilityTab.PropTypes = {
  classname: PropTypes.any,
  header: PropTypes.any,
  largeText: PropTypes.any,
  linkHref: PropTypes.any,
  linkText: PropTypes.any,
  iconSpan: PropTypes.any,
  Icon: PropTypes.any,
  Count: PropTypes.any,
  SustainabilityGroups: PropTypes.any,
};

export default SustainabilityTab;
